import { QueryClient } from "@tanstack/react-query";

/**
 * The app-wide QueryClient, in its own module so non-React code (auth-store)
 * can reach it. Critical: it MUST be wiped on logout/impersonation — the
 * in-memory cache survives SPA navigation, so switching accounts in the same
 * tab would otherwise serve the previous tenant's data (dashboard counts,
 * onboarding state, even patient lists) for up to `staleTime` with no refetch.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,
			refetchOnWindowFocus: false,
			staleTime: 30_000,
			// Keep query data in cache long enough to persist + survive an offline
			// reload (Offline-first Phase 1). The persister filters to successes.
			gcTime: 24 * 60 * 60 * 1000,
		},
	},
});

/** Drop every in-memory query so the next session starts from zero. */
export function clearQueryCache() {
	queryClient.clear();
}
